import { Compass } from 'lucide-react';
import styled from 'styled-components';

import { Flex } from '@/components/base';
import TooltipV2 from '@/components/Tooltip/TooltipV2';
import AMP_KEYS from '@/configs/amp-track-keys';
import useModalStore from '@/stores/pure/ModalStore';
import { track } from '@/utils/track/track';

type Props = {
  shrinked: boolean;
};

const NavigatorButton = (props: Props) => {
  const setModalStatus = useModalStore((state) => state.setModalStatus);

  const onNavigatorClick = () => {
    track(AMP_KEYS.GNB_NAVIGATOR_CLICK);
    setModalStatus('navigatorFloatModal', true);
  };

  return (
    <div className="flex items-center justify-center">
      <TooltipV2
        tooltipNode="Navigator"
        shortcut="⌘ P"
        offset={props.shrinked ? { x: 48, y: -40 } : undefined}
      >
        <NavButtonStyle
          onClick={onNavigatorClick}
          style={{
            width: '32px',
            height: '32px',
            justifyContent: 'center',
            fontSize: 14,
          }}
        >
          <Compass size={16} />
        </NavButtonStyle>
      </TooltipV2>
    </div>
  );
};

const NavButtonStyle = styled(Flex).attrs({
  a: 'center',
})`
  font-size: 14px;
  height: 24px;
  width: 24px;
  border-radius: 8px;
  color: ${(props) => props.theme.colors.sidebar_foreground};
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: ${(props) => props.theme.colors.sidebar_accent};
  }
`;

export default NavigatorButton;
